export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/rent_pre_registrations/state.js